import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, useTheme } from "@mui/material";
import { MainStyledTypography } from "./SubHeader/SubHeaderStyled";
import SubHeaderBannerShell from "./SubHeader/SubHeaderBannerShell";
import useIsMobile from "../../hooks/useIsMobile";
import { getSubHeaderBannerMetrics } from "./SubHeader/subHeaderBannerStyles";

/**
 * Compact list-page hero banner shared by Chat, Saved Search, Account Settings, etc.
 * Reuses the Search page banner shell (gradient, decorative marks, height, padding).
 */
export default function PageListBanner({ title, subtitle, testId = "page-list-banner" }) {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { titleFontSize, titleLineHeight, titleFontWeight } = getSubHeaderBannerMetrics(isMobile);

  return (
    <SubHeaderBannerShell testId={testId}>
      <Grid item>
        <MainStyledTypography
          component="h1"
          sx={{
            color: theme.palette.primary.main,
            fontSize: titleFontSize,
            lineHeight: titleLineHeight,
            fontWeight: titleFontWeight,
          }}
        >
          {title}
        </MainStyledTypography>
      </Grid>
      {subtitle ? (
        <Grid item>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.25, fontSize: 13, fontWeight: 500, lineHeight: "18px" }}
          >
            {subtitle}
          </Typography>
        </Grid>
      ) : null}
    </SubHeaderBannerShell>
  );
}

PageListBanner.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  testId: PropTypes.string,
};
